import * as React from 'react';
import { default as BaseIndexPage } from './[lang]/index';

type Props = {};

const IndexPage: React.FC<Props> = function (props) {
    // @ts-ignore
    return <BaseIndexPage lang="en" {...props} />;
};

export default IndexPage;

export { getStaticProps } from 'server/page-props';
